// extracted by mini-css-extract-plugin
export default {"custom-link":"horizontal-org-chart_custom-link__+B8sx"};